import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useUrlSearchParams } from 'use-url-search-params';
import { Card, Button, OverlayTrigger, Form, Tooltip } from 'react-bootstrap';
import toast, { Toaster } from 'react-hot-toast';
import { Badge } from 'reactstrap';
import CsLineIcons from '../../../../cs-line-icons/CsLineIcons';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import Pagination from '@vlsergey/react-bootstrap-pagination';
import { SORTING_ORDER } from '../../../../constants/index';
import moment from 'moment';
import axios from 'axios';
import UserAuthKey from '../../../../components/Common/UserAuthKey';
import { setUserData } from '../../../../Redux/user/userSlice';
import { FINANCE_ROLE_ID, SHOW_ROOM_MANAGER_ROLE_ID, CUSTOMER_CARE_MANAGER_ROLE_ID, CUSTOMER_CARE_SUPERVISOR_ROLE_ID, STORE_CUSTOMER_CARE_SUPERVISOR_ROLE_ID } from '../../../../constants/roles'; // Import the role constants
import { fetchComplaintsLists, updateRefundStatus } from '../actions/action';

import {
  Table,
  Row,
  Col,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Spinner,
} from 'reactstrap';
import ReactDrawer from 'react-drawer';
import 'react-drawer/lib/react-drawer.css';
import DHPagination from '../../../../components/Pagination';
import FilterSearchQueue from '../../../../components/FilterSearch/FilterSearchQueue';

import './ComplaintsList.css';
import { color } from 'echarts/lib/export';
// import ManageStoreRefundExport from '../StoreRefunds/components/ManageStoreRefundExport';

const ManageComplaintsList = (props) => {
  const { stores, refreshList } = props;
  const location = useLocation();
  const [btnprimary, setBtnprimary] = useState(false);
  const dispatch = useDispatch();
  const [copiedId, setCopiedId] = useState(null);
  const [sortingName, setSortingName] = useState({ id: 'sort.date_asc' });
  const [paginationValue, setPaginationValue] = useUrlSearchParams({ page: 0 });
  const [limitValue, setLimitValue] = useUrlSearchParams({ limit: 10 });
  const [sortingValue, setSortingValue] = useUrlSearchParams({
    sort: '_date',
    order: SORTING_ORDER.ASC,
  });
  const [searchValue, setSearchValue] = useUrlSearchParams({ search: '' });
  const [customActiveTab, setcustomActiveTab] = useState('All');
  let is_split = 0;
  const { country = [] } = useSelector((state) => state.country);
  let currentCountry = localStorage.getItem('WEBSITE_COUNTRY');
  const splitVal = location?.pathname.split('/');
  const [advancedFilter, setAdvancedFilter] = useState({});
  const [searchFilter, setSearchFilter] = useUrlSearchParams({ search: '' });
  const [statusFilter, setStatusFilter] = useUrlSearchParams({ status: 'All' });

  
  const fetchComplaintsList = useCallback(async (data) => {
    try {
      setDataLoading(true);
      await fetchComplaintsLists({
        params: data,
        dispatch,
      }); // send data directly, not { params: data }
    } catch (error) {
      setDataLoading(false);
      console.error('Error fetching orders:', error);
    } finally {
      setDataLoading(false);
    }
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchComplaintsList({
        start: Number(paginationValue.page * limitValue.limit),
        limit: Number(limitValue.limit),
        sort: { value: sortingValue.sort, order: Number(sortingValue.order) },
        search_qry: searchValue.search,
        status: customActiveTab,
        orderBy: 'id',
        country: currentCountry,
        advancedFilter,
        stores,
      });
    }, 300);
    return () => clearTimeout(delay);
  }, [
    paginationValue.page,
    limitValue,
    advancedFilter,
    searchFilter,
    statusFilter,
    stores,
    refreshList, // <-- add this dependency
  ]);

  const { complaintsList = [], isLoading } = useSelector((state) => state.complaints);

  const [isDataLoading, setDataLoading] = useState(false);

  const { data } = complaintsList;
  const complaintData = data;

  // The orders list keeps its rows and its page count in one wrapper
  // (listOrders.orderList / listOrders.recordsTotal). Here `data` IS the row
  // array, so the count has to come from its siblings - reading it off the
  // array gave undefined and the pager rendered no page buttons at all.
  const paginationMeta = complaintsList?.pagination || {};
  const perPageCount = Number(limitValue.limit) || 10;
  const currentPageIndex = Number(paginationValue.page) || 0;
  // This API answers with pagination: { page, perPage, total, totalPages }
  const complaintPages = Math.max(
    1,
    Number(
      paginationMeta.totalPages ??
        paginationMeta.total_pages ??
        complaintsList?.recordsTotal ??
        complaintsList?.total_pages ??
        (paginationMeta.total
          ? Math.ceil(Number(paginationMeta.total) / perPageCount)
          : 0),
    ),
    // a full page implies there is another one
    complaintData?.length === perPageCount
      ? currentPageIndex + 2
      : currentPageIndex + 1,
  );

  let UserRoleID = '';
  let UserCountry = '';

  if (localStorage.getItem('authUser')) {
    const userObj = JSON.parse(localStorage.getItem('authUser'));
    if (userObj?.role_id !== undefined) {
      UserRoleID = userObj?.role_id;
      UserCountry = userObj?.country;
    }
  }

  let pageIndex = Number(complaintData?.length) > 0 ? Number(paginationValue.page * limitValue.limit) : 0;

  const [viewMode, setViewMode] = useState(false);

  const customStyles = `
  .refundOrder .react-drawer-drawer {
    width: ${viewMode ? '50%' : ''} !important;
  }
`;

    // State for approve confirmation modal
  const [approveModal, setApproveModal] = useState({ open: false, order: null });

  // Approve refund handler (replace with actual logic)
  const handleApproveRefund = async () => {
    setDataLoading(true);
    if (!approveModal.order) return;
    try {
      await updateRefundStatus({
        refund_id: approveModal?.complaint?.id || approveModal?.complaint?.RefundId || approveModal?.complaint?.refund_id,
        status: 'approved',
        dispatch,
      });
      toast.success('Refund approved!');
      setApproveModal({ open: false, order: null });
      // Optionally reload list
      fetchComplaintsList({
        start: Number(paginationValue.page * limitValue.limit),
        limit: Number(limitValue.limit),
        sort: { value: sortingValue.sort, order: Number(sortingValue.order) },
        search_qry: searchValue.search,
        status: customActiveTab,
        orderBy: 'id',
        country: currentCountry,
        advancedFilter,
        stores,
      });
    } catch (error) {
      toast.error('Failed to approve refund.');
    }
    finally {
      setDataLoading(false);
    }
  };

  const handleSearch = (e) => {
    setSearchValue({ search: e.target.value });
  };

  return (
    <>
      <>
        <style>{customStyles}</style>
        <Row>
          <Col xl={12}>
             <Row>
              <Col>
                {/* <ManageStoreRefundExport /> */}
              </Col>
              <Col xl={2} md={6} className="mb-3 ">
                <div className="searchBox">
                  <div className="d-inline-block float-md-start me-1 mb-1 search-input-container w-100 bg-foreground">
                    <Form.Control
                      type="text"
                      placeholder="Search"
                      value={searchValue.search}
                      id="listSearch"
                      onChange={handleSearch}
                    />
                    <span className="search-magnifier-icon searchIcon">
                      <CsLineIcons icon="search" />
                    </span>
                    <span className="search-delete-icon d-none">
                      <CsLineIcons icon="close" />
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
            <>
              <div className=" dt-table">
                <div className="table-responsive">
                  <Table className="OrderListTable table mb-0">
                    <thead>
                      <tr>
                         <th>SI.No</th>
                      <th nowrap="nowrap">Date</th>
                      <th nowrap="nowrap">Complaint Details</th>
                      <th nowrap="nowrap">Order No</th>
                      <th nowrap="nowrap">Customer Details</th>
                      <th nowrap="nowrap">Country</th>
                      <th>Status</th>
                      <th nowrap="nowrap">Assigned To</th>
                      <th nowrap="nowrap">Created By</th>
                      <th nowrap="nowrap">Action</th>
                      </tr>
                    </thead>
                    {isLoading || isDataLoading ? (
                      <>
                        <Spinner className="ms-2 sploader" color="primary" />
                        <tbody>
                          {[...Array(2)].map((_, index) => (
                            <tr>
                              <td>
                                <p className="placeholder-glow">
                                  <span className="placeholder col-2"></span>
                                </p>
                              </td>
                              <td>
                                <p className="placeholder-glow">
                                  <span className="placeholder col-12"></span>
                                  <span className="placeholder col-6"></span>
                                  <span
                                    className="placeholder"
                                    style={{ width: '25%' }}
                                  ></span>
                                  <span className="placeholder w-75"></span>
                                </p>
                              </td>
                              <td>
                                {' '}
                                <p className="placeholder-glow d-flex flex-column gap-1">
                                  <span className="placeholder col-6"></span>
                                </p>
                              </td>
                              <td>
                                {' '}
                                <p className="placeholder-glow">
                                  <span className="placeholder col-6"></span>
                                </p>
                              </td>
                              <td>
                                {' '}
                                <p className="placeholder-glow">
                                  <span className="placeholder col-6"></span>
                                </p>
                              </td>
                              <td>
                                {' '}
                                <p className="placeholder-glow">
                                  <span className="placeholder col-6"></span>
                                </p>
                              </td>
                              <td>
                                <p className="placeholder-glow">
                                  <span className="placeholder col-6"></span>
                                  <span
                                    className="placeholder"
                                    style={{ width: '25%' }}
                                  ></span>
                                </p>
                              </td>
                              <td colSpan={2}></td>
                            </tr>
                          ))}
                        </tbody>
                      </>
                    ) : complaintData?.length > 0 ? (
                      <>
                        {(complaintData || []).map((complaint, index) => {
                          pageIndex++;
                          let cdate = complaint.createdAt,
                            orderDt = moment(new Date(cdate)).format(
                              'Do MMM, YYYY'
                            ),
                            orderTime = moment(new Date(cdate)).format(
                              'h:mm:ss a'
                            );
                          return (
                            <tbody key={index}>
                              <tr>
                                <th scope="row">{pageIndex}</th>
                                <td>
                                  <span className="fs-12">
                                    {orderDt}
                                  </span>
                                  <p className="fs-12">
                                    {orderTime}
                                  </p>
                                </td>
                                <td className="ReturnInfo1">
                                    <span className="fs-12">
                                    Complaint No: {complaint?.complaintNo}
                                  </span>
                                </td>
                                <td className="ReturnInfo1">
                                    <span className="fs-12">
                                    {complaint?.orderNo}
                                  </span>
                                </td>
                                <td>
                                  <span className="fs-12">
                                    {complaint?.customerName}
                                  </span>
                                  <p className="fs-12">
                                    {complaint?.mobile}
                                    <br />
                                    {complaint?.email}
                                  </p>
                                </td>
                                <td>{complaint?.country}
                                </td>
                                <td>
                                  <Badge
                                    color={
                                      complaint?.statusText === 'New'
                                        ? 'success'
                                        : complaint?.statusText === 'In Progress'
                                        ? 'info'
                                        : complaint?.statusText === 'Resolved'
                                        ? 'success'
                                        : 'secondary'
                                    }
                                    className="badge badge-pill"
                                  >
                                    {complaint?.statusText}
                                  </Badge>
                                </td>
                                <td>{complaint?.assignedTo || '-'}</td>
                                <td>{complaint?.createdBy || '-'}</td>
                                <td>
                                  <div className="action-flex-container">
                                     
                                      <span
                                        className="btn btn-sm btn-outline-warning waves-effect waves-light"
                                        title="View Complaint Info"
                                        onClick={() => {
                                          // Open the new page with the required URL
                                          if (complaint?.complaintNo) {
                                            window.open(`/complaints/manage-complaints/${complaint.complaintNo}`, '_blank');
                                          }
                                        }}
                                      >
                                        <i className="mdi mdi-eye-outline"></i>
                                      </span>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          );
                        })}
                      </>
                    ) : (
                      <>
                        <tbody>
                          <tr>
                            <td colSpan={10}>No Records found</td>
                          </tr>
                        </tbody>
                      </>
                    )}
                  </Table>
                </div>
                {complaintData?.length > 0 ? (
                  <DHPagination
                    totalPages={complaintPages}
                    currentPage={paginationValue.page}
                    setPaginationValue={setPaginationValue}
                    setLimitValue={setLimitValue}
                  />
                ) : null}
              </div>
            </>
          </Col>
        </Row>
      </>
    </>
  );
};

export default ManageComplaintsList;
